/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as environments from "../../../../../../environments";
import * as core from "../../../../../../core";
import * as Flatfile from "../../../../../index";
import urlJoin from "url-join";
import * as serializers from "../../../../../../serialization/index";
import * as errors from "../../../../../../errors/index";
export class Config {
    constructor(_options = {}) {
        this._options = _options;
    }
    /**
     * Returns all space configs for an account
     *
     * @param {Flatfile.deprecated.ListSpaceConfigsRequest} request
     * @param {Config.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     *
     * @example
     *     await client.deprecated.config.list()
     */
    list(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__list(request, requestOptions));
    }
    async __list(request = {}, requestOptions) {
        const { environmentId } = request;
        const _queryParams = {};
        if (environmentId != null) {
            _queryParams["environmentId"] = environmentId;
        }
        const _response = await (this._options.fetcher ?? core.fetcher)({
            url: urlJoin((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.FlatfileEnvironment.Production, "/space-configs"),
            method: "GET",
            headers: {
                Authorization: await this._getAuthorizationHeader(),
                "X-Disable-Hooks": requestOptions?.xDisableHooks ?? this._options?.xDisableHooks ?? "true",
                "X-Fern-Language": "JavaScript",
                "X-Fern-Runtime": core.RUNTIME.type,
                "X-Fern-Runtime-Version": core.RUNTIME.version,
                ...requestOptions?.headers,
            },
            contentType: "application/json",
            queryParameters: _queryParams,
            requestType: "json",
            timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
            maxRetries: requestOptions?.maxRetries,
            abortSignal: requestOptions?.abortSignal,
        });
        if (_response.ok) {
            return {
                data: serializers.deprecated.ListSpaceConfigsResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                }),
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 400:
                    throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }), _response.rawResponse);
                default:
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        switch (_response.error.reason) {
            case "non-json":
                throw new errors.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.rawBody,
                    rawResponse: _response.rawResponse,
                });
            case "timeout":
                throw new errors.FlatfileTimeoutError("Timeout exceeded when calling GET /space-configs.");
            case "unknown":
                throw new errors.FlatfileError({
                    message: _response.error.errorMessage,
                    rawResponse: _response.rawResponse,
                });
        }
    }
    /**
     * Updates an existing Space Config and optionally migrates all spaces using the config
     *
     * @param {Flatfile.deprecated.UpdateSpaceConfigRequest} request
     * @param {Config.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     *
     * @example
     *     await client.deprecated.config.replace({
     *         body: {
     *             slug: "slug",
     *             name: "name",
     *             blueprints: [{
     *                     slug: "slug",
     *                     name: "name",
     *                     primary: undefined,
     *                     sheets: [{
     *                             name: "name",
     *                             description: undefined,
     *                             slug: undefined,
     *                             readonly: undefined,
     *                             allowAdditionalFields: undefined,
     *                             mappingConfidenceThreshold: undefined,
     *                             access: undefined,
     *                             fields: [{
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }, {
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }],
     *                             actions: undefined,
     *                             metadata: undefined,
     *                             constraints: undefined,
     *                             treatments: undefined,
     *                             collection: undefined
     *                         }, {
     *                             name: "name",
     *                             description: undefined,
     *                             slug: undefined,
     *                             readonly: undefined,
     *                             allowAdditionalFields: undefined,
     *                             mappingConfidenceThreshold: undefined,
     *                             access: undefined,
     *                             fields: [{
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }, {
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }],
     *                             actions: undefined,
     *                             metadata: undefined,
     *                             constraints: undefined,
     *                             treatments: undefined,
     *                             collection: undefined
     *                         }]
     *                 }, {
     *                     slug: "slug",
     *                     name: "name",
     *                     primary: undefined,
     *                     sheets: [{
     *                             name: "name",
     *                             description: undefined,
     *                             slug: undefined,
     *                             readonly: undefined,
     *                             allowAdditionalFields: undefined,
     *                             mappingConfidenceThreshold: undefined,
     *                             access: undefined,
     *                             fields: [{
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }, {
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }],
     *                             actions: undefined,
     *                             metadata: undefined,
     *                             constraints: undefined,
     *                             treatments: undefined,
     *                             collection: undefined
     *                         }, {
     *                             name: "name",
     *                             description: undefined,
     *                             slug: undefined,
     *                             readonly: undefined,
     *                             allowAdditionalFields: undefined,
     *                             mappingConfidenceThreshold: undefined,
     *                             access: undefined,
     *                             fields: [{
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }, {
     *                                     type: "string",
     *                                     key: "key",
     *                                     label: undefined,
     *                                     description: undefined,
     *                                     constraints: undefined,
     *                                     readonly: undefined,
     *                                     appearance: undefined,
     *                                     actions: undefined,
     *                                     metadata: undefined,
     *                                     treatments: undefined,
     *                                     alternativeNames: undefined,
     *                                     config: undefined
     *                                 }],
     *                             actions: undefined,
     *                             metadata: undefined,
     *                             constraints: undefined,
     *                             treatments: undefined,
     *                             collection: undefined
     *                         }]
     *                 }],
     *             actions: undefined,
     *             access: undefined,
     *             namespace: undefined,
     *             labels: undefined,
     *             translationsPath: undefined
     *         }
     *     })
     */
    replace(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__replace(request, requestOptions));
    }
    async __replace(request, requestOptions) {
        const { migrate, body: _body } = request;
        const _queryParams = {};
        if (migrate != null) {
            _queryParams["migrate"] = migrate.toString();
        }
        const _response = await (this._options.fetcher ?? core.fetcher)({
            url: urlJoin((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.FlatfileEnvironment.Production, "/space-configs"),
            method: "PUT",
            headers: {
                Authorization: await this._getAuthorizationHeader(),
                "X-Disable-Hooks": requestOptions?.xDisableHooks ?? this._options?.xDisableHooks ?? "true",
                "X-Fern-Language": "JavaScript",
                "X-Fern-Runtime": core.RUNTIME.type,
                "X-Fern-Runtime-Version": core.RUNTIME.version,
                ...requestOptions?.headers,
            },
            contentType: "application/json",
            queryParameters: _queryParams,
            requestType: "json",
            body: serializers.deprecated.SpacePatternConfig.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
            timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
            maxRetries: requestOptions?.maxRetries,
            abortSignal: requestOptions?.abortSignal,
        });
        if (_response.ok) {
            return {
                data: serializers.deprecated.SpacePatternResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                }),
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 400:
                    throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }), _response.rawResponse);
                default:
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        switch (_response.error.reason) {
            case "non-json":
                throw new errors.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.rawBody,
                    rawResponse: _response.rawResponse,
                });
            case "timeout":
                throw new errors.FlatfileTimeoutError("Timeout exceeded when calling PUT /space-configs.");
            case "unknown":
                throw new errors.FlatfileError({
                    message: _response.error.errorMessage,
                    rawResponse: _response.rawResponse,
                });
        }
    }
    /**
     * Creates a new Space Config
     *
     * @param {Flatfile.deprecated.SpacePatternConfig} request
     * @param {Config.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     *
     * @example
     *     await client.deprecated.config.create({
     *         slug: "slug",
     *         name: "name",
     *         blueprints: [{
     *                 slug: "slug",
     *                 name: "name",
     *                 primary: undefined,
     *                 sheets: [{
     *                         name: "name",
     *                         description: undefined,
     *                         slug: undefined,
     *                         readonly: undefined,
     *                         allowAdditionalFields: undefined,
     *                         mappingConfidenceThreshold: undefined,
     *                         access: undefined,
     *                         fields: [{
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }, {
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }],
     *                         actions: undefined,
     *                         metadata: undefined,
     *                         constraints: undefined,
     *                         treatments: undefined,
     *                         collection: undefined
     *                     }, {
     *                         name: "name",
     *                         description: undefined,
     *                         slug: undefined,
     *                         readonly: undefined,
     *                         allowAdditionalFields: undefined,
     *                         mappingConfidenceThreshold: undefined,
     *                         access: undefined,
     *                         fields: [{
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }, {
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }],
     *                         actions: undefined,
     *                         metadata: undefined,
     *                         constraints: undefined,
     *                         treatments: undefined,
     *                         collection: undefined
     *                     }]
     *             }, {
     *                 slug: "slug",
     *                 name: "name",
     *                 primary: undefined,
     *                 sheets: [{
     *                         name: "name",
     *                         description: undefined,
     *                         slug: undefined,
     *                         readonly: undefined,
     *                         allowAdditionalFields: undefined,
     *                         mappingConfidenceThreshold: undefined,
     *                         access: undefined,
     *                         fields: [{
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }, {
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }],
     *                         actions: undefined,
     *                         metadata: undefined,
     *                         constraints: undefined,
     *                         treatments: undefined,
     *                         collection: undefined
     *                     }, {
     *                         name: "name",
     *                         description: undefined,
     *                         slug: undefined,
     *                         readonly: undefined,
     *                         allowAdditionalFields: undefined,
     *                         mappingConfidenceThreshold: undefined,
     *                         access: undefined,
     *                         fields: [{
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }, {
     *                                 type: "string",
     *                                 key: "key",
     *                                 label: undefined,
     *                                 description: undefined,
     *                                 constraints: undefined,
     *                                 readonly: undefined,
     *                                 appearance: undefined,
     *                                 actions: undefined,
     *                                 metadata: undefined,
     *                                 treatments: undefined,
     *                                 alternativeNames: undefined,
     *                                 config: undefined
     *                             }],
     *                         actions: undefined,
     *                         metadata: undefined,
     *                         constraints: undefined,
     *                         treatments: undefined,
     *                         collection: undefined
     *                     }]
     *             }],
     *         actions: undefined,
     *         access: undefined,
     *         namespace: undefined,
     *         labels: undefined,
     *         translationsPath: undefined
     *     })
     */
    create(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__create(request, requestOptions));
    }
    async __create(request, requestOptions) {
        const _response = await (this._options.fetcher ?? core.fetcher)({
            url: urlJoin((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.FlatfileEnvironment.Production, "/space-configs"),
            method: "POST",
            headers: {
                Authorization: await this._getAuthorizationHeader(),
                "X-Disable-Hooks": requestOptions?.xDisableHooks ?? this._options?.xDisableHooks ?? "true",
                "X-Fern-Language": "JavaScript",
                "X-Fern-Runtime": core.RUNTIME.type,
                "X-Fern-Runtime-Version": core.RUNTIME.version,
                ...requestOptions?.headers,
            },
            contentType: "application/json",
            requestType: "json",
            body: serializers.deprecated.SpacePatternConfig.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
            timeoutMs: requestOptions?.timeoutInSeconds != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
            maxRetries: requestOptions?.maxRetries,
            abortSignal: requestOptions?.abortSignal,
        });
        if (_response.ok) {
            return {
                data: serializers.deprecated.SpacePatternResponse.parseOrThrow(_response.body, {
                    unrecognizedObjectKeys: "passthrough",
                    allowUnrecognizedUnionMembers: true,
                    allowUnrecognizedEnumValues: true,
                    skipValidation: true,
                    breadcrumbsPrefix: ["response"],
                }),
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 400:
                    throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }), _response.rawResponse);
                default:
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        switch (_response.error.reason) {
            case "non-json":
                throw new errors.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.rawBody,
                    rawResponse: _response.rawResponse,
                });
            case "timeout":
                throw new errors.FlatfileTimeoutError("Timeout exceeded when calling POST /space-configs.");
            case "unknown":
                throw new errors.FlatfileError({
                    message: _response.error.errorMessage,
                    rawResponse: _response.rawResponse,
                });
        }
    }
    async _getAuthorizationHeader() {
        const bearer = await core.Supplier.get(this._options.token);
        if (bearer != null) {
            return `Bearer ${bearer}`;
        }
        return undefined;
    }
}
